import { Injectable, inject } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ConfirmDialogComponent, type ConfirmDialogData } from '@components/confirm-dialog/confirm-dialog.component';
import { firstValueFrom } from 'rxjs';

/**
 * Thin wrapper around the shared yes/no {@link ConfirmDialogComponent}. Exposes a single awaitable
 * `open()` so call sites read top-to-bottom without observables or callbacks:
 *
 *   const confirmed = await this.confirmation.open(data);
 *   if (!confirmed) return;
 *   try {
 *     ...
 *   } catch {
 *     ...
 *   }
 */
@Injectable({ providedIn: 'root' })
export class ConfirmationService {
  private readonly dialog = inject(MatDialog);

  /** Opens the confirmation dialog and resolves to `true` only when the user confirms. */
  async open(data: ConfirmDialogData): Promise<boolean> {
    const confirmed = await firstValueFrom(this.dialog.open(ConfirmDialogComponent, { data }).afterClosed());
    return confirmed === true;
  }
}
